<template>
  <div class="page-container">
    <!-- <a-tabs :default-active-key="tabKey" @change="handleTabChange">
      <a-tab-pane v-for="item in tabPaneConfig" :key="item.key" :tab="item.tab">
      </a-tab-pane>
    </a-tabs> -->
    <TableList
      :columns="tabPaneConfig[tabKey - 1].columns"
      :tableData="tabPaneConfig[tabKey - 1].tableData"
      :loading="tabPaneConfig[tabKey - 1].loading"
      :scroll="false"
      :pagination="tabPaneConfig[tabKey - 1].pagination"
      @change="handleTableChange"
    >
      <div slot="queryArea" class="query-area">
        <div>
          <j-dict-select-tag
            style="width: 170px; margin-right: 15px"
            placeholder="请选择年级"
            v-model="queryParam.gradeId"
            dictCode="school_grade,grade_name,id,0=delete_flag order by sort_order"
            :isShowEmpty="false"
            @select="$set(queryParam, 'classId', undefined)"
          />
          <j-dict-select-tag
            style="width: 170px; margin-right: 15px"
            placeholder="请选择班级"
            v-model="queryParam.classId"
            :dictCode="
              'school_class,name,id,grade_id=' + (!queryParam.gradeId ? -1 : queryParam.gradeId)
            "
            :async="true"
            :disabled="!queryParam.gradeId"
            :isShowEmpty="false"
          />
          <a-range-picker v-model="dateRange" class="search-space" style="width: 240px" />
          <j-dict-select-tag
            v-model="queryParam.careList"
            placeholder="关爱等级"
            dictCode="care_list"
            class="search-space"
          />
          <a-input-search
            v-model="queryParam.studentName"
            placeholder="请输入学生名字"
            class="search-space"
            style="width: 170px"
            @change="searchName"
          />
          <a-button type="primary" @click="queryTable">查询</a-button>
        </div>
        <a-button
          type="primary"
          icon="download"
          style="margin-left: auto"
          @click="handleExportXls('危机干预学生清单')"
        >
          导出
        </a-button>
      </div>
      <template slot="action" slot-scope="{ record }">
        <div class="action-detail">
          <!-- <span @click="viewTutorRecord(record)">添加干预记录</span>
          <a-divider type="vertical" /> -->
          <span @click="addLedger(record)">添加台账</span>
          <a-divider type="vertical" />
          <span @click="addVisitRecord(record)">添加家访记录</span>
          <a-divider type="vertical" />
          <span @click="viewArchives(record)">查看档案</span>
        </div>
      </template>
    </TableList>
    <AddInterveneRecord ref="interveneRecordRef" @refreshData="loadData" />
    <CommunRecordModal ref="communRecordModalRef" />
    <EffectFeedbackModal ref="effectFeedbackModalRef" />
    <!-- 添加家访记录 -->
    <AddVisitRecordModal ref="visitRecordModalRef" @refreshData="loadData"/>
    <!-- 添加台账 -->
    <AddLedgerModal ref="addLedgerModalRef" @refreshData="loadData"/>
  </div>
</template>
<script>
import TableList from '@/components/chart/TableList'
import { getAction } from '@api/manage'
import { getDictCodeData, simpleDebounce } from '@/utils/util'
import AssessModal from '@/comUi/AssessModal'
import CommunRecordModal from './components/CommunRecordModal'
import EffectFeedbackModal from './components/EffectFeedbackModal'
import AddInterveneRecord from '@/comUi/AddInterveneRecord'
import AddVisitRecordModal from './components/AddVisitRecordModal'
import AddLedgerModal from '@/views/school/mentalHealth/TutorStandBook/components/StudentTutor/components/AddLedgerModal'
import moment from 'moment'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'

const tablePagination = {
  current: 1,
  pageSize: 10,
  pageSizeOptions: ['10', '50', '100'],
  showTotal: (total, range) => {
    return range[0] + '-' + range[1] + ' 共' + total + '条'
  },
  showQuickJumper: true,
  showSizeChanger: true,
  total: 0,
}

export default {
  name: 'CrisisIntervent',
  components: {
    TableList,
    AssessModal,
    CommunRecordModal,
    EffectFeedbackModal,
    AddInterveneRecord,
    AddVisitRecordModal,
    AddLedgerModal,
  },
  mixins: [JeecgListMixin],
  data() {
    return {
      tabKey: 1,
      queryParam: {
        // type: 0,
        // name: '',
      },
      dateRange: [],
      tabPaneConfig: [
        {
          tab: '学生咨询',
          key: 1,
          columns: [
            {
              title: '序号',
              dataIndex: 'index',
              align: 'center',
            },
            {
              title: '班级',
              dataIndex: 'studentClass',
              align: 'center',
            },
            {
              title: '学生',
              dataIndex: 'name',
              align: 'center',
            },
            {
              title: '关爱等级',
              dataIndex: 'careList_dictText',
              align: 'center',
            },
            {
              title: '最近沟通时间',
              dataIndex: 'maxTutorTime',
              align: 'center',
              customRender: (_, record) => {
                return record.maxTutorTime || '-'
              },
            },
            {
              title: '辅导次数',
              dataIndex: 'tutorNum',
              align: 'center',
              customRender: (_, record) => {
                return record.tutorNum || 0
              },
            },
            {
              title: '家长电话',
              dataIndex: 'phone',
              align: 'center',
              customRender: (_, record) => {
                return record.phone.length >= 15 ? (
                  <a-tooltip>
                    <template slot="title">{record.phone}</template>
                    {record.phone.substring(0, 15) + '...'}
                  </a-tooltip>
                ) : (
                  record.phone
                )
              },
            },
            // {
            //   title: '辅导方法',
            //   dataIndex: 'tutoringMethod',
            //   align: 'center',
            //   customRender: (_, record) => {
            //     const res = getDictCodeData('tutoring_method', record.tutoringMethod)
            //     return res.text
            //   },
            // },
            // {
            //   title: '问题原因',
            //   dataIndex: 'tagId',
            //   align: 'center',
            //   customRender: (_, record) => {
            //     const res = getDictCodeData('emotional_type', record.tagId)
            //     return res.text
            //   },
            // },
            // {
            //   title: '干预措施',
            //   dataIndex: 'interventionId',
            //   align: 'center',
            //   customRender: (_, record) => {
            //     const res = getDictCodeData('intervention', record.interventionId)
            //     return res.text
            //   },
            // },
            // {
            //   title: '效果反馈',
            //   dataIndex: 'effectFeedback',
            //   align: 'center',
            //   customRender: (_, record) => {
            //     const res = getDictCodeData('effect_feedback', record.effectFeedback)
            //     return res.text
            //   },
            // },
            // {
            //   title: '具体情况说明',
            //   dataIndex: 'comment',
            //   align: 'center',
            //   customRender: (_, record) => {
            //     return record.comment.length >= 15 ? (
            //       <a-tooltip>
            //         <template slot="title">{record.comment}</template>
            //         {record.comment.substring(0, 15) + '...'}
            //       </a-tooltip>
            //     ) : (
            //       record.comment
            //     )
            //   },
            // },
            {
              title: '操作',
              dataIndex: 'action',
              align: 'center',
              scopedSlots: { customRender: 'action' },
            },
          ],
          tableData: [],
          loading: false,
          pagination: { ...tablePagination },
        },
      ],
      url: {
        list: '/ddUser/allChildren',
        exportXlsUrl: '/aigoes/schoolWarnRecord/crisisInterventionExport',
      },
      detailModalData: [],
    }
  },
  created() {
    this.loadData()
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
  },
  methods: {
    handleTabChange(key) {
      this.tabKey = key
      this.queryParam = {}
      this.detailModalData = []
      this.loadData()
    },
    onRangeChange() {},
    // 分页变化
    handleTableChange(page) {
      this.$set(this.tabPaneConfig[this.tabKey - 1], 'pagination', page)
      this.loadData()
    },
    // 查询
    queryTable() {
      console.log('查询条件--', this.queryParam)
      this.$set(this.tabPaneConfig[this.tabKey - 1], 'pagination', { ...tablePagination })
      this.loadData()
    },
    searchName: simpleDebounce(function (event) {
      console.log('搜索条件--', event.target.value)
      const name = event.target.value
      this.getTableData()
    }, 500),
    loadData() {
      switch (this.tabKey) {
        case 1:
          this.$set(this.url, 'list', '/aigoes/schoolWarnRecord/getCrisisInterventionList')
          break
      }
      this.getTableData()
      // this.queryParam = {}
    },
    getTableData() {
      this.$set(this.tabPaneConfig[this.tabKey - 1], 'loading', true)
      const params = {
        pageNo: this.tabPaneConfig[this.tabKey - 1].pagination.current,
        pageSize: this.tabPaneConfig[this.tabKey - 1].pagination.pageSize,
        ...this.queryParam,
        beginDate: this.dateRange[0] && moment(this.dateRange[0]).format('YYYY-MM-DD'),
        endDate: this.dateRange[1] && moment(this.dateRange[1]).format('YYYY-MM-DD'),
      }
      getAction(this.url.list, params)
        .then((res) => {
          console.log('获取列表数据--', res)
          if (res.success) {
            const tableData = res.result.records.length
              ? res.result.records.map((item, index) => ({
                  ...item,
                  index: index + 1,
                }))
              : []
            this.$set(this.tabPaneConfig[this.tabKey - 1], 'tableData', tableData)
            this.$set(this.tabPaneConfig[this.tabKey - 1].pagination, 'total', res.result.total)
          }
        })
        .finally(() => {
          this.$set(this.tabPaneConfig[this.tabKey - 1], 'loading', false)
        })
    },
    viewTutorRecord(record) {
      this.$refs.interveneRecordRef.showModal(record)
    },
    viewArchives(record) {
      this.$router.push({
        path: '/school/mentalHealth/ArchivesViewPage',
        query: {
          studentId: record.studentId,
        },
      })
    },
    viewCommunRecord(record) {
      this.$refs.communRecordModalRef.showModal(record)
    },
    viewFeedback(record) {
      this.$refs.effectFeedbackModalRef.showModal(record)
    },
    // 添加台账
    addLedger(row){
      this.$refs.addLedgerModalRef.showModal({
        gradeId:row.gradeId,
        classId:row.classId,
        studentId:row.studentId
      },"append")
    },
    // 添加家访记录
    addVisitRecord(row) {
      this.$refs.visitRecordModalRef.showModal(
        {
          gradeId: row.gradeId,
          classId: row.classId,
          studentId: row.studentId,
        },
        'append'
      )
    },
  },
}
</script>
<style scoped lang="less">
.query-area {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.action-detail {
  min-width: 100px !important;
  color: #0077fa !important;
  cursor: pointer !important;
}
.search-space {
  width: 140px;
  margin-right: 15px;
}
</style>
